module.exports = __webpack_public_path__ + "static/1-b2f839a39bbafca2b098fdcd4ccfa0f7.png";